import type { IMasterDataRawRetailerAssociationRepository } from "@src/domain/repositories/masterData";
import type { UpdateMasterDataRawRetailerAssociationDTO } from "@src/domain/dto/masterData";

export class UpdateMasterDataRawRetailerAssociationUseCase {
  private readonly repository: IMasterDataRawRetailerAssociationRepository;

  constructor(repository: IMasterDataRawRetailerAssociationRepository) {
    this.repository = repository;
  }

  execute(params: UpdateMasterDataRawRetailerAssociationDTO) {
    return this.repository.updateRawAssociation(params);
  }
}
